import type React from 'react';

/**
 * Render a tabs header.
 */
export function BlockTabsHeader(props: { children: React.ReactNode }): React.ReactElement {
    const { children } = props;
    return (
        <div className="relative z-[1] mb-[-1px] flex w-full items-center whitespace-nowrap print:hidden">
            <div className="flex max-w-full" contentEditable={false}>
                <div className="pointer-events-auto flex max-w-full rounded-tl-md rounded-tr-md">
                    {children}
                </div>
            </div>
        </div>
    );
}
